const iocsListColumn = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Label",
    dataIndex: "label",
    key: "label",
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
  },
]
export default iocsListColumn;


// WEBPACK FOOTER //
// src/containers/admin/iocs/IocsList.utils.js